import { Flex, Text, TypographyProps } from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import React from "react"

type Props = {
  published: boolean
  url?: string
  dotSize?: number
  fontSize?: TypographyProps["fontSize"]
  fontWeight?: TypographyProps["fontWeight"]
}

const StatusIndicator = ({
  published, url, dotSize = 3.5, fontSize, fontWeight,
}: Props) => (
  <Flex align="center">
    <Icon
      color={getStatusIndicatorColor(published, url)}
      size={dotSize}
      icon="dot"
      mr={2}
    />
    {fontSize || fontWeight ? (
      <Text fontSize={fontSize || "xl"} fontWeight={fontWeight || "bold"}>{published ? "Published" : "Draft"}</Text>
    ) : (
      <Text as="span">{published ? "Published" : "Draft"}</Text>
    )}
  </Flex>
)

export const getStatusIndicatorColor = (published: boolean, url?: string): string => {
  if (published) {
    return "green.300"
  }

  if (url) {
    return "orange.300"
  }

  return "gray.300"
}

export default StatusIndicator
